/* =======================================================================
   Knowledge Base — the article tree in the left column. Azure item 416.

   Every module section is always rendered, in the same order, whether or
   not it has anything to do with the current search. Sections vanishing
   and reappearing under the cursor made the sidebar feel unstable, so
   during a search the irrelevant ones recede instead. Unwritten stubs
   match on their title and keywords, so a gap in coverage is visible
   rather than silently absent.
   ======================================================================= */
import { ARTICLES, MODULES, MOD_STATUS, modLocked } from './articles';
import { matches, concepts } from './search';
import { refOf } from './kbSession';
import { countFlags } from './render';

export default function KbTree({ query, activeSlug, collapsed, onToggle, onOpen }){
  const q = (query || '').trim();
  const isSearch = q.length >= 2;

  let hitSet = null, qc = null;
  if (isSearch){
    hitSet = new Set(matches(q).map(r => r.a.slug));
    qc = concepts(q);
  }

  return (
    <div className="kbtree">
      {MODULES.map(mod => {
        const all = ARTICLES.filter(a => a.module === mod);
        /* not ready (MOD_SOON): the name and its label, and nothing to open */
        if (modLocked(mod)) return (
          <div className="grp collapsed locked" key={mod}>
            <div className="grp-btn" aria-disabled="true">
              <svg className="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6"><path d="M6 9l6 6 6-6"/></svg>
              {mod}
            </div>
            {MOD_STATUS[mod] ? <div className="grp-dev"><span className="tag dev">{MOD_STATUS[mod]}</span></div> : null}
          </div>
        );
        let items = all, matched = false;

        if (isSearch){
          const hits = all.filter(a => {
            if (hitSet.has(a.slug)) return true;
            if (!a.stub) return false;
            const ac = concepts(a.title + ' ' + (a.keywords || []).join(' '));
            return [...qc].some(c => ac.has(c));
          });
          matched = hits.length > 0;
          if (matched) items = hits;
        }

        const open = isSearch ? matched : !collapsed[mod];
        const cls = 'grp' + (open ? '' : ' collapsed') + (isSearch && !matched ? ' dim' : '');

        return (
          <div className={cls} key={mod}>
            <button className="grp-btn" type="button" onClick={() => onToggle(mod, isSearch)}>
              <svg className="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6"><path d="M6 9l6 6 6-6"/></svg>
              {mod}
              <span className="cnt">{all.filter(a => !a.stub).length}</span>
            </button>
            {/* under the heading, not beside it: the tree is too narrow for both */}
            {MOD_STATUS[mod] ? <div className="grp-dev"><span className="tag dev">{MOD_STATUS[mod]}</span></div> : null}
            <div className="grp-items">
              {items.map(a => {
                const nv = countFlags(a);
                return (
                  <a
                    key={a.slug}
                    className={'doclink' + (a.stub ? ' stub' : '') + (activeSlug === a.slug ? ' active' : '')}
                    onClick={e => { e.preventDefault(); onOpen(a); }}
                    href={'#' + a.slug}
                  >
                    {refOf(a) ? <span className="kb-ref">{refOf(a)}</span> : null}
                    {a.title}
                    {a.stub
                      ? <span className="tag">not written</span>
                      : (nv ? <span className="tag v">{nv} verify</span> : null)}
                  </a>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
